// Main exports
export { WixCodeLSPServer } from "./server.js";
export { FileLogger as Logger } from "./utils/logger.js";

// Types
export type {
  ServerConfig,
  ServerStats,
  LSPMessage,
} from "./types/server.js";

// Factory function for easy server creation
import { WixCodeLSPServer } from "./server.js";
import type { ServerConfig } from "./types/server.js";

export function createLSPServer(config: ServerConfig): WixCodeLSPServer {
  return new WixCodeLSPServer(config);
}
